import React from "react";

import avatar from "../../assets/images/general/avatar.svg";
import check from "../../assets/images/general/check.svg";
import checkWhite from "../../assets/images/general/check-white.svg";
import clear from "../../assets/images/general/clear.svg";
import coinsAnimation from "../../assets/images/oracles/coinsAnimation.gif";
import copy from "../../assets/images/general/copy.svg";
import copyDone from "../../assets/images/general/copy-done.svg";
import cube from "../../assets/images/general/cube.svg";
import fees from "../../assets/images/general/fees.svg";
import fox from "../../assets/images/general/fox.svg";
import gear from "../../assets/images/general/gear.svg";
import globe from "../../assets/images/general/globe.svg";
import handMoney from "../../assets/images/oracles/handMoney.svg";
import handMoneyBlack from "../../assets/images/account/handMoneyBlack.svg";
import hoverEditAvatar from "../../assets/images/general/hover-edit-avatar.svg";
import info from "../../assets/images/general/info.svg";
import lock from "../../assets/images/general/lock.svg";
import logoPlaceholder from "../../assets/images/general/logo-upload.svg";
import wideLogoPlaceholder from "../../assets/images/general/wide-logo-upload.svg";
import notification from "../../assets/images/general/notification.svg";
import pencil from "../../assets/images/general/pencil.svg";
import plus from "../../assets/images/general/plus.svg";
import protocol from "../../assets/images/general/protocol.svg";
import search from "../../assets/images/general/search.svg";
import share from "../../assets/images/general/share.svg";
import star from "../../assets/images/general/star.svg";
import swap from "../../assets/images/general/swap.svg";
import upload from "../../assets/images/general/upload.svg";
import user from "../../assets/images/account/user.svg";
import userPhoto from "../../assets/images/general/user-photo.svg";
import wallet from "../../assets/images/account/wallet.svg";
import walletAvatar from "../../assets/images/general/wallet-avatar.svg";
import watch from "../../assets/images/general/watch.svg";
import metamask from "../../assets/images/market/metamask.png";
import marketUserAvatar from "../../assets/images/market/User_avatar.png";

const Icons = {
	avatar,
	check,
	checkWhite,
	clear,
	copy,
	coinsAnimation,
	copyDone,
	cube,
	fees,
	fox,
	gear,
	globe,
	info,
	lock,
	pencil,
	plus,
	protocol,
	search,
	swap,
	upload,
	defaultUserPhoto: userPhoto,
	walletAvatar,
	logoPlaceholder,
	wideLogoPlaceholder,
	notification,
	hoverEditAvatar,
	share,
	handMoney,
	handMoneyBlack,
	wallet,
	user,
	star,
	watch,
	metamask,
	marketUserAvatar
};

const Icon = (props) => {
	const { icon } = props;

	return Icons[icon] ? (
		<img src={Icons[icon]} alt={`${icon}-icon`} {...props} />
	) : null;
};

export default Icon;
